export function Logo(){
    return(
        <a href="/">
            <div className="logo"></div>
        </a>
    );
}